import React from "react";
import useMedia from "use-media";
import { useDispatch, useSelector } from "react-redux";
import { selectAuthStatus } from "reducers/auth";
import { selectHeaderMenuOpen, setHeaderMenuOpen } from "reducers/header";
import { useOnClickOutside } from "helpers/useOnClickOutside";
import HeaderMenu from "./HeaderMenu";

//icons
import Logo from "assets/Logo.svg";
import MenuIcon from "assets/Icon_Btn_Menu.png";
import CloseMenuIcon from "assets/Icon_Btn_06.png";
import { Link } from "@reach/router";
import { useGetUserInfo } from "helpers/useGetUserInfo";
import { selectUserInfo } from "reducers/userInfo";

type MobileHeaderProps = {
  setMobileNavOpen(open: boolean): void;
  isMobileNavOpen: boolean;
};

const MobileHeader: React.FC<MobileHeaderProps> = ({
  setMobileNavOpen,
  isMobileNavOpen,
}) => {
  const dispatch = useDispatch();
  const authStatus = useSelector(selectAuthStatus);
  const isMenuOpen = useSelector(selectHeaderMenuOpen);

  const tablet = useMedia({ maxWidth: 1200 });

  const openHeaderMenu = () => !isMenuOpen && dispatch(setHeaderMenuOpen());

  const isSignedIn = authStatus === "signed_in";

  useGetUserInfo();
  const { userInfo } = useSelector(selectUserInfo);

  return (
    <div className="MobileHeader WidthContent">
      {isSignedIn && (
        <div
          className="BtnMobileNav"
          onClick={() => {
            !isMobileNavOpen && setMobileNavOpen(!isMobileNavOpen);
          }}
        >
          <img src={MenuIcon} alt="Nav" />
        </div>
      )}

      <div className="Logo">
        <Link to="/">
          <img src={Logo} alt="Logo" />
        </Link>
      </div>
      {isSignedIn && (
        <div className="User">
          <div className="MenuIcon" onClick={() => openHeaderMenu()}>
            <span>
              {`${userInfo?.firstName[0] ?? ""}${userInfo?.lastName[0] ?? ""}`}
            </span>
            <HeaderMenu />
          </div>
        </div>
      )}
    </div>
  );
};

export { MobileHeader };
